<template>
  <div>
    <el-page-header class="detail-head" @back="goBack" content="委托单详情"> </el-page-header>
    <el-divider class="detail-divider"></el-divider>
    <el-tabs>
      <el-tab-pane label="基本信息">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="120px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="委托单号" class="detail-form-item" prop="code">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="委托单名称" class="detail-form-item" prop="name">
                      <el-input size="medium" v-model="entity.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="送检订单号" class="detail-form-item">
                      <el-input size="medium" v-model="entity.inspect.code" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="送检订单名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.inspect.name" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                        <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="数据账号类型" class="detail-form-item">
                      <el-radio-group v-model="entity.accountType" @change="changeAccountType">
                        <el-radio label="1">系统默认</el-radio>
                        <el-radio label="2">客户账号</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="客户账号用户名" class="detail-form-item" prop="username">
                      <el-input size="medium" v-model="entity.username"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="客户账号密码" class="detail-form-item" prop="password">
                      <el-input size="medium" v-model="entity.password"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="检测数量" class="detail-form-item">
                      <el-input size="medium" v-model="entity.testCount" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="已完成检测数量" class="detail-form-item">
                      <el-input size="medium" v-model="entity.finishedTestCount" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="未完成检测数量" class="detail-form-item">
                      <el-input size="medium" v-model="entity.unfinishedTestCount" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="完成检测时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.finishedTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="检测详情列表">
        <div class="detail-containe-product">
          <div class="detail-filter">
            <div class="detail-filter-item">
              <el-tag size="medium" class="label">仪器状态:</el-tag>
              <el-radio-group v-model="insStatusCode" @change="querySubList">
                <el-radio label="all">全部</el-radio>
                <el-radio label="1">可取在库房</el-radio>
                <el-radio label="2">检测中</el-radio>
                <el-radio label="3">已取</el-radio>
              </el-radio-group>
            </div>
            <div class="detail-filter-item">
              <el-tag size="medium" class="label">证书状态:</el-tag>
              <el-radio-group v-model="certStatusCode" @change="querySubList">
                <el-radio label="all">全部</el-radio>
                <el-radio label="1">已完成</el-radio>
                <el-radio label="0">未完成</el-radio>
              </el-radio-group>
            </div>
            <div class="detail-filter-item">
              <el-tag size="medium" class="label">缴费状态:</el-tag>
              <el-radio-group v-model="payStatusCode" @change="querySubList">
                <el-radio label="all">全部</el-radio>
                <el-radio label="1">已缴费</el-radio>
                <el-radio label="0">未缴费</el-radio>
              </el-radio-group>
            </div>
          </div>
          <el-scrollbar>
            <el-table :data="entity.delegateSubList" border style="width: 100%" stripe>
              <el-table-column prop="no" label="序号" width="50"> </el-table-column>
              <el-table-column prop="sourceSubCode" label="分委托单" width="100"> </el-table-column>
              <el-table-column prop="certCoName" label="证书单位" width="200"> </el-table-column>
              <el-table-column prop="insName" label="仪器名称"> </el-table-column>
              <el-table-column prop="insFactoryNumber" label="出厂编号" width="200"> </el-table-column>
              <el-table-column prop="insStatusName" label="仪器状态" width="100"> </el-table-column>
              <el-table-column prop="testTypeName" label="检测类型" width="80"> </el-table-column>
              <el-table-column prop="expectedDate" label="预计完检" width="100"> </el-table-column>
              <el-table-column prop="testCost" label="检测费用" width="80"> </el-table-column>
              <el-table-column label="是否退检" width="80">
                <template #default="scope">
                  <div class="column-tag">
                    <el-tag v-if="scope.row.isExit" type="danger" size="mini">{{ scope.row.isExit?"是":"否" }}</el-tag>
                    <el-tag v-else size="mini">{{ scope.row.isExit?"是":"否" }}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="isForce" label="是否强检" width="80">
                <template #default="scope">
                  <div class="column-tag">
                    <el-tag v-if="scope.row.isForce" type="danger" size="mini">{{ scope.row.isForce?"是":"否" }}</el-tag>
                    <el-tag v-else size="mini">{{ scope.row.isForce?"是":"否" }}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="证书状态" width="80">
                <template #default="scope">
                  <div class="column-tag">
                    <el-tag v-if="scope.row.certStatusCode==='0'" type="danger" size="mini">{{ scope.row.certStatusName}}</el-tag>
                    <el-tag v-if="scope.row.certStatusCode==='1'" type="success" size="mini">{{ scope.row.certStatusName}}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="缴费状态" width="80">
                <template #default="scope">
                  <div class="column-tag">
                    <el-tag v-if="scope.row.payStatusCode==='0'" type="danger" size="mini">{{ scope.row.payStatusName}}</el-tag>
                    <el-tag v-if="scope.row.payStatusCode==='1'" type="success" size="mini">{{ scope.row.payStatusName}}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="certTypeName" label="证书类型" width="80"> </el-table-column>
              <el-table-column label="操作" width="100">
                <template #default="scope">
                  <el-link v-if="scope.row.certStatusCode==='1'" :href="scope.row.certUrl" type="primary">下载证书</el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Delegate } from "@/script/apps/inspect/entity/InspectEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { DelegateService } from "@/script/apps/inspect/service/DelegateService";
import { ElMessage } from "element-plus";
import {
  createInspectContext,
  InspectService,
} from "@/script/apps/inspect/service/InspectService";
import { QueryParam } from "@/script/core/service/DataService";
import { DelegateSubService } from "@/script/apps/inspect/service/DelegateSubService";

@Options({})
export default class DelegateDetail extends BaseDetail {
  private service = new DelegateService();
  private insStatusCode = "all";
  private certStatusCode = "all";
  private payStatusCode = "all";

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_ins_delegate",
      "/ins/delegate",
      "/ins/delegate",
      this.service
    );
    data.entity = {
      user: { realName: "" },
      inspect: { code: "", name: "" },
    };
    data.statesName = "ins-delegate-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入委托单号", trigger: "blur" }],
    name: [{ required: true, message: "请输入委托单名称", trigger: "blur" }],
    username: [
      { required: false, message: "请输入客户账号用户名", trigger: "blur" },
    ],
    password: [
      { required: false, message: "请输入客户账号密码", trigger: "blur" },
    ],
  };

  protected initOptions() {
    super.initOptions();
    this.insStatusCode = "all";
    this.certStatusCode = "all";
    this.payStatusCode = "all";
  }

  public newEntity() {
    const inspectId = Number(this.$route.query.inspectId);
    const entity: Delegate = {
      inspectId,
      state: "0",
      accountType: "1",
      inspect: { code: "", name: "" },
    };

    const inspectContext = createInspectContext();
    inspectContext.service.loadEntity(
      inspectContext.serviceData.loadApiName,
      { id: inspectId },
      (data: any) => {
        const delegate = this.entity as Delegate;
        delegate.inspect = data;
      }
    );
    return entity;
  }

  public afterLoad() {
    const delegate = this.entity as Delegate;
    this.injectDetailData(delegate.delegateSubList!, []);
    this.generateRowNo();
  }

  private querySubList() {
    const delegate = this.entity as Delegate;
    const query = new QueryParam();
    const queryEntity = {
      mainId: delegate.id,
      insStatusCode: this.insStatusCode,
      certStatusCode: this.certStatusCode,
      payStatusCode: this.payStatusCode,
    };
    query.entity = queryEntity;
    new DelegateSubService().loadList(
      query,
      (data: any) => {
        delegate.delegateSubList = data.list;
        this.injectDetailData(delegate.delegateSubList!, []);
        this.generateRowNo();
      },
      function (error: Error) {
        ElMessage.error("加载列表失败，失败原因：" + error.message);
      },
      "/api/ins/delegate/sub/list/query"
    );
  }

  private changeAccountType() {
    const delegate = this.entity as Delegate;
    if (delegate.accountType === "1") {
      this.rules.username[0].required = false;
      this.rules.password[0].required = false;
    } else {
      this.rules.username[0].required = true;
      this.rules.password[0].required = true;
    }
  }

  download(scope: any) {}
}
</script>

<style lang="scss">
.detail-filter {
  display: flex;
  margin-bottom: 10px;
}

.detail-filter-item {
  display: flex;
  margin-right: 40px;
  align-items: center;
}

.detail-filter-item .label {
  margin-right: 20px;
}
</style>
